// ** Aggregator for per-module translation catalogs (react-intl classic system)
// Each module exports { en, mx, ... } with flat dictionaries following the
// project convention: key === English source string, value === translation.
import crm from './crm';
import bbva from './bbva';
import quotationsV3 from './quotationsV3';

// quotationsV3 goes first: a later module overrides an earlier one, and the
// quoter must not change translations the CRM or BBVA already define.
const modules = { quotationsV3, crm, bbva };

export const mergeModuleMessages = (lang) =>
  Object.values(modules).reduce(
    (acc, mod) => ({ ...acc, ...(mod[lang] || {}) }),
    {}
  );
